import * as React from 'react'

function HandshakeDealCircle(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.09 21h2.022a1.777 1.777 0 001.777-1.777V12.11a1.777 1.777 0 00-1.777-1.778H5.42M26.58 10.333h-1.69a1.777 1.777 0 00-1.778 1.778v7.112A1.777 1.777 0 0024.89 21h2.023"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.139 19.53h-1.147c-.381 0-.759.08-1.105.24l-5.61 2.554M14.193 11.557a2.652 2.652 0 00-2.233-.218l-3.07 1.105"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.325 11.248L19.491 9.56a2.668 2.668 0 00-2.524.203l-3.48 2.254a2.009 2.009 0 101.94 3.504l2.074-.968"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 28c6.627 0 12-5.373 12-12S22.627 4 16 4 4 9.373 4 16s5.373 12 12 12z"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.501 14.552l1.054.956a2.668 2.668 0 01.01 3.943l-2.689 2.461a2.665 2.665 0 01-3.59.01l-1.849-1.677a2.663 2.663 0 00-1.58-.666"
        stroke="#1F2D27"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export { HandshakeDealCircle }
